"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _gatsby = require("gatsby");

var RichText = function RichText(props) {
  var children = props.children;

  var parse = function parse(string) {
    return (0, _htmlReactParser.default)(string, {
      replace: function replace(domNode) {
        if (domNode.type === 'tag' && domNode.name === 'a') {
          if (domNode.attribs.href.includes('http')) {
            return /*#__PURE__*/_react.default.createElement("a", {
              href: domNode.attribs.href,
              target: "_blank"
            }, domNode.children.map(function (o) {
              return parse(o.data);
            }));
          } else {
            return /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
              to: domNode.attribs.href
            }, domNode.children.map(function (o) {
              return parse(o.data);
            }));
          }
        }
      }
    });
  };

  return typeof children === 'string' ? parse(children) : '';
};

var _default = RichText;
exports.default = _default;